import { useState } from 'react';
import { Settings2 } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { tr } from '@/i18n/copy';

export default function ConfigurationTile({title, description, icon: Icon = Settings2, children, action, actionLabel, size = 'small'}) {
  const [open,setOpen]=useState(false);
  return <Dialog open={open} onOpenChange={setOpen}>
    <DialogTrigger asChild><button type="button" className="tps-config-tile"><Icon className="h-8 w-8 text-primary"/><span className="font-semibold">{title}</span><span className="text-xs text-muted-foreground">{description}</span><span className="tps-config-action">{tr('Configura')}</span></button></DialogTrigger>
    <DialogContent className={`tps-configuration-dialog ${size === 'medium' ? 'sm:max-w-xl' : 'sm:max-w-sm'}`}><DialogHeader className="pr-6 text-left"><DialogTitle>{title}</DialogTitle></DialogHeader>{children}{action&&<Button variant="outline" className="justify-self-start" onClick={()=>{setOpen(false);action();}}>{actionLabel}</Button>}</DialogContent>
  </Dialog>;
}
